<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">学历认证</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>身份认证总状态：</label>
          <el-select v-model="overallAuthState" placeholder="Select" style="width: 8em">
            <el-option v-for="item in overallAuthStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>学历认证：</label>
          <el-select v-model="eduState" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in eduStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>学历：</label>
          <el-select v-model="education" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in educationArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>简历状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>证明材料状态：</label>
          <el-select v-model="isDel" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in isDelArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>认证类型：</label>
          <el-select v-model="authType" placeholder="Select" style="width: 7.4em">
            <el-option v-for="item in authTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)" v-loading="searchLoading"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div style="display: flex; align-items: center;">
<!--          <el-button type="primary" v-loading="updateLoading" @click="updateReadState">已查看</el-button>-->
          <ElButtons icon="Comment" @click="sendSysMsg">发送通知</ElButtons>
          <el-button type="primary" @click="updateSpecial">专区操作</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            border
            @cell-click="toggleSelection"
            v-loading="listLoading"
            @selection-change="selsChange"
            @header-click="selsAll"
        >
          <el-table-column type="selection" width="55" align="center" class-name="cursor"/>
          <el-table-column property="updateTime" label="时间" v-if="checkColList.indexOf('时间') > -1"/>
          <el-table-column property="" label="所在专区" v-if="checkColList.indexOf('所在专区') > -1" width="90">
            <template #default="scope">
              <p v-for="(item, index) in scope.row.specialsUserList" :key="index" style="margin: 8px 0;">
                <span style="color: #409eff; cursor: pointer;" @dblclick="removeSpecialUser(scope.$index,index)">{{ item.name }}</span>
                {{ item.isShow==1?'(外展)':'' }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="头像" v-if="checkColList.indexOf('头像') > -1" width="105">
            <template #default="scope">
              <HeadImg :images="scope.row.headImg" />
            </template>
          </el-table-column>
          <el-table-column label="用户信息" v-if="checkColList.indexOf('用户信息') > -1" width="200">
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid,city,birth"/>
            </template>
          </el-table-column>
          <el-table-column label="实名信息" v-if="checkColList.indexOf('实名信息') > -1" width="160">
            <template #default="scope">
<!--              <p>实名： {{ scope.row.identityAuth.identityName }}</p>-->
<!--              <get-plain title="身份证号：" :code="scope.row.identityAuth.identityCode" :uid="scope.row.uid" :type="10" :subType="4"/>-->
              <span v-if="scope.row.identityAuth">
                {{ scope.row.identityAuth.identityState == 2?'实名：' + scope.row.identityAuth.identityName:scope.row.identityAuth.zhimaState == 1?'实名：' + scope.row.identityAuth.zhimaCertName + ' (芝麻)':scope.row.identityAuth.baiduState == 1?'实名：' + scope.row.identityAuth.baiduCertName + ' (百度)':'' }}
              </span>
              <div v-if="scope.row.identityAuth">
                <p v-if="scope.row.identityAuth.identityState == 2"><get-plain title="身份证号：" :code="scope.row.identityAuth.identityCode" :uid="scope.row.uid" :type="10" :subType="1"/></p>
                <p v-else-if="scope.row.identityAuth.zhimaState == 1"><get-plain title="身份证号：" :code="scope.row.identityAuth.zhimaCertCode" :uid="scope.row.uid" :type="10" :subType="2"/></p>
                <p v-else-if="scope.row.identityAuth.baiduState == 1"><get-plain title="身份证号：" :code="scope.row.identityAuth.baiduCertCode" :uid="scope.row.uid" :type="10" :subType="3"/></p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="身份认证总状态" v-if="checkColList.indexOf('身份认证总状态') > -1" width="130">
            <template #default="scope">
              <p>{{scope.row.identityAuth.overallAuthState == 0 ? "未提交" : scope.row.identityAuth.overallAuthState == 1 ? "待审核" : scope.row.identityAuth.overallAuthState == 2 ? "审核通过" : scope.row.identityAuth.overallAuthState == 3 ? "审核不通过" : ""}}</p>
            </template>
          </el-table-column>
          <el-table-column label="学历信息" v-if="checkColList.indexOf('学历信息') > -1" width="160">
            <template #default="scope">
              <el-button type="primary" size="small" @click="delDate(scope.$index)" v-loading="scope.row.delDateLoading" v-if="scope.row.eduDel==0">使认证材料失效</el-button>
              <el-button type="info" size="small" v-if="scope.row.eduDel==1" :disabled="true">认证材料已失效</el-button>
              <p>学校：{{scope.row.schoolName}}</p>
              <p style="color: blue;">学历：{{scope.row.education==1?'初中':scope.row.education==2?'中专/职高/技校':scope.row.education==3?'高中':scope.row.education==4?'大专':scope.row.education==5?'本科':scope.row.education==6?'硕士':scope.row.education==7?'博士':scope.row.education==8?'博士后':''}}</p>
              <p>类型：{{scope.row.studyType==0?'-':scope.row.studyType==1?'其他':scope.row.studyType==2?'全日制':scope.row.studyType==3?'非全日制':scope.row.studyType==4?'继续教育':''}}</p>
            </template>
          </el-table-column>
          <el-table-column label="在线验证码" v-if="checkColList.indexOf('在线验证码') > -1" width="110">
            <template #default="scope">
              <p class="chsi-code" @click="goCodeDialog(scope.row)">{{scope.row.chsiCode}}</p>
            </template>
          </el-table-column>
          <el-table-column label="认证材料" v-if="checkColList.indexOf('认证材料') > -1" width="130">
            <template #default="scope">
              <el-image style="width: 80px;" fit="cover" :src="scope.row.smallImg" @click="jobDialog(scope.$index, scope.row)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </template>
          </el-table-column>
          <el-table-column label="学历认证" v-if="checkColList.indexOf('学历认证') > -1" width="110">
            <template #default="scope">
              <span>{{scope.row.eduState==0?'默认客户端保存没去申请认证':scope.row.eduState==1?'待认证':scope.row.eduState==2?'已认证':scope.row.eduState==3?'认证失败':''}}</span>
            </template>
          </el-table-column>
          <el-table-column label="认证类型" v-if="checkColList.indexOf('认证类型') > -1" width="110">
            <template #default="scope">
              <span>{{scope.row.authType==0?'其他材料':scope.row.authType==1?'毕业证书':scope.row.authType==2?'学历证明':scope.row.authType==3?'学信网自助验证':scope.row.authType==4?'学信网在线验证码':scope.row.authType==5?'真实性承诺':''}}</span>
            </template>
          </el-table-column>
          <el-table-column label="简历状态" v-if="checkColList.indexOf('简历状态') > -1" width="110">
            <template #default="scope">
              <span>{{scope.row.resumeState==0?'未查看':scope.row.resumeState==1?'待审核':scope.row.resumeState==2?'审核通过':scope.row.resumeState==3?'审核不通过':''}}</span>
            </template>
          </el-table-column>
          <el-table-column property="remark" label="不通过原因" v-if="checkColList.indexOf('不通过原因') > -1" width="110"/>
          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="200">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
// import BtnGroup from '../../components/BtnGroup'
import {delUserSpecials, getAuthEduPageList, updateAdviceReadState, delAuthEduData} from '../../api/url'
import { getFormData, postJson, postFormData } from '../../api/api'
import Dialog from '../../assets/js/dialog'
import SendSystemMessage from "@/components/SendSystemMessage";
import UserLogDialog from '../../components/UserLog/UserLogDialog'
import ImgViewer from '../../assets/js/imageViewer'
import {common, auth} from "@/assets/shared/select-constant";
import UserLog from "@/components/UserLog/UserLog";
import GetPlain from "@/components/resume/GetPlain";
import EducationDialog from "@/views/auth/components/EducationDialog";
import AuthSpecialDialog from "./components/AuthSpecialDialog";
import educationCodeDialog from "@/views/auth/components/educationCodeDialog";

export default {
  name: "AuthEducation",
  components: { DatePickerRange, SearchComponents, UserLog, GetPlain },
  data() {
    return {
      sexArray: common.sexList,
      sex: common.sexList[0]['value'],

      overallAuthStateArray: auth.overallAuthStateList,
      overallAuthState: auth.overallAuthStateList[3]['value'],

      // authTypeArray: auth.authTypeList,
      // authType: auth.authTypeList[0]['value'],

      eduStateArray: auth.stateList,
      eduState: auth.stateList[2]['value'],

      isDelArray: auth.isDelList,
      isDel: auth.isDelList[2]['value'],

      educationArray: auth.eduList,
      education: auth.eduList[0]['value'],

      stateArray: auth.resStateList,
      state: auth.resStateList[0]['value'],

      authTypeArray: [
        {label : '不限', value : -1},
        {label : '其他材料', value : 0},
        {label : '毕业证书', value : 1},
        {label : '学历证明', value : 2},
        {label : '学信网自助验证', value : 3},
        {label : '学信网在线验证码', value : 4},
        {label : '真实性承诺', value : 5},
      ],
      authType: -1,


      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '昵称', value : 3},
        {label : '用户ID', value : 2},
        {label : '身份证号', value : 4}
      ],
      searchType: 2,
      searchValue: '',

      //刷新组
      colList: ['时间','所在专区', '头像', '用户信息', '实名信息', '身份认证总状态', '学历信息', '在线验证码', '认证材料', '学历认证', '认证类型', '简历状态', '不通过原因', '用户日志'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      //选中id
      idArray: [],
      userIdArray: [],
      //选中性别
      userSexArray: [],

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.sex = -1;
      this.authType = -1;
      this.overallAuthState = 2;
      // this.authType = -1;
      this.eduState = 1;
      this.isDel = 0;
      this.education = -1;
      this.state = -1;
      this.startTime = '';
      this.endTime = '';
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.id);
      this.userIdArray = sels.map(item => item.userId);
      this.userSexArray = sels.map(item => item.sex);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.id) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['authType'] = this.authType;
      param['overallAuthState'] = this.overallAuthState;
      param['eduState'] = this.eduState;
      param['isDel'] = this.isDel;
      param['education'] = this.education;
      param['state'] = this.state;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getAuthEduPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    // updateReadState() {
    //   if(this.idArray.length > 0) {
    //     this.$confirm('确认批量处理为【已查看】').then(()=>{
    //       this.updateLoading = true;
    //       let _this = this;
    //       let param = {};
    //       param['ids'] = this.idArray;
    //       postFormData(updateAdviceReadState, param).then((data) => {
    //         let {code, msg} = data;
    //         if(code == 200) {
    //           _this.$message({
    //             showClose: true,
    //             duration: 1000,
    //             message: msg,
    //             type: 'success'
    //           });
    //           for(let j=0;j<_this.idArray.length;j++){
    //             for(let i=0;i<_this.pageDataList.length;i++) {
    //               if(_this.pageDataList[i]['id'] == _this.idArray[j]) {
    //                 _this.pageDataList.splice(i,1);
    //                 i--;
    //               }
    //             }
    //           }
    //           if(_this.pageDataList.length == 0){
    //             _this.getPage();
    //           }
    //         }else {
    //           _this.$message({
    //             showClose: true,
    //             duration: 1000,
    //             message: msg,
    //             type: 'warning'
    //           });
    //         }
    //         _this.updateLoading = false;
    //       })
    //           .catch(()=>{
    //             _this.updateLoading = false;
    //           })
    //     })
    //   }else {
    //     this.$message({
    //       showClose: true,
    //       duration: 1000,
    //       message: '请至少选择一条记录进行操作',
    //       type: 'warning'
    //     })
    //   }
    // },

    //图片预览

    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList
      })
    },

    toggleSelection(row, column, cell, event) {

      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['user_log'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }


    },

    //学历认证审核
    jobDialog(idx, row){
      let educationForm = Object.assign({}, row);
      Dialog.open({
        title: '学历认证审核',
        component: EducationDialog,
        data: {
          educationForm: educationForm,
          width: '1000px'
        },
        confirm: (result) => {
          this.pageDataList.splice(idx,1);
          if(this.pageDataList.length == 0){
            this.getPage();
          }
        }
      })
    },

    //发送系统消息
    sendSysMsg() {
      if(this.idArray.length == 0) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一条记录进行操作',
          type: 'warning'
        })
        return false
      }
      Dialog.open({
        title: '发送小助手通知',
        component: SendSystemMessage,
        data: {
          userIdArray: this.userIdArray,
          width: '600px'
        },
        confirm: () => {

        }
      })
    },

    //删除认证材料
    delDate(idx) {
      this.$confirm('确认使认证材料失效？')
          .then(() => {
                this.pageDataList[idx]['delDateLoading'] = true;
                let param = {};
                param['id'] = this.pageDataList[idx]['id'];
                param['userId'] = this.pageDataList[idx]['userId'];
                param['isDel'] = 1;
                let _this = this;
                postFormData(delAuthEduData, param).then((data) => {
                  let { msg, code } = data;
                  if(code == 200) {
                    _this.$message({
                      showClose: true,
                      duration: 1000,
                      message: msg,
                      type: 'success'
                    })
                    _this.pageDataList.splice(idx,1);
                  } else{
                    _this.$message({
                      showClose: true,
                      duration: 1000,
                      message: msg,
                      type: 'warning'
                    })
                  }
                  _this.pageDataList[idx]['delDateLoading'] = false;
                })
                    .catch((data) => {
                      _this.pageDataList[idx]['delDateLoading'] = false;
                    })
              }
          )
          .catch(() => {})
    },

    //取消专区
    removeSpecialUser(userIdx, specialIdx) {
      this.$confirm('请确认是否继续移除操作', {
        type: 'warning'
      }).then(() => {
        let _this = this;
        let param = {};
        param['userId'] = this.pageDataList[userIdx]['userId'];
        param['specialsId'] = this.pageDataList[userIdx]['specialsUserList'][specialIdx]['id'];
        postFormData(delUserSpecials, param).then(function(data) {
          let {
            code,
            msg
          } = data;
          if(code == 200) {
            _this.pageDataList[userIdx]['specialsUserList'].splice(specialIdx, 1);
            _this.$message({
              showClose: true,
              duration: 1000,
              message: '操作成功',
              type: 'success'
            });
          } else {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
        })
            .catch(function(response) {})
      })
          .catch(() => {

          })
    },

    //专区操作
    updateSpecial() {
      if(this.idArray.length > 0) {
        let s = this.userSexArray[0]
        let isSex = this.userSexArray.every((val) => {
          return val == s;
        });
        if(!isSex) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: '勾选用户性别不一致，无法进行专区操作',
            type: 'warning'
          })
          return false
        }
        Dialog.open({
          title: '专区选择',
          component: AuthSpecialDialog,
          data: {
            idArray: this.userIdArray,
            sex: s,
            width: '500px'
          },
          confirm: () => {
            this.getPage();
          }
        })
      } else {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一位用户进行专区操作',
          type: 'warning'
        })
      }
    },

    goCodeDialog(row) {
      let codeForm = Object.assign({}, row);
      Dialog.open({
        title: '在线验证码审核',
        component: educationCodeDialog,
        data: {
          codeForm: codeForm,
          width: '600px'
        },
        confirm: () => {
          this.getPage();
        }
      })
    },



  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>
.chsi-code:hover {
  color: #409eff;
  cursor: pointer;
}
.el-img-error {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
}
</style>
